import React, { lazy } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const DashBoard = lazy(() => import("../pages/DashBoard"));
const Login = lazy(() => import("../pages/Login"));
const Services = lazy(() => import("../pages/Services"));
const Statistics = lazy(() => import("../pages/Statistics"));
const Orders = lazy(() => import("../pages/Orders"));
const Settings = lazy(() => import("../pages/Settings"));
const Calendar = lazy(() => import("../pages/Calendar"));
const Finances = lazy(() => import("../pages/Finances"));
const NotFound = lazy(() => import("../pages/NotFound"));

// const LoadingFallback = () => (
//   <div>
//     <LoaderAnimation/>
//   </div>
// );

// const SuspenseWrapper = ({ children }) => {
//   const [showContent, setShowContent] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowContent(true);
//     }, 500);

//     return () => clearTimeout(timer);
//   }, []);

//   if (!showContent) {
//     return <LoadingFallback />;
//   }

//   return <Suspense fallback={<LoadingFallback />}>{children}</Suspense>;
// };

const getToken = () => {
  const data = localStorage.getItem("userPartnerData");
  if (!data) return null;

  try {
    const parsed = JSON.parse(data);
    return parsed.token;
  } catch {
    return null;
  }
};

const isAuthenticated = () => !!getToken();

const ProtectedRoute = ({ children }) => {
  const { lang } = useParams();
  const language = lang || "am";

  return isAuthenticated() ? (
    children
  ) : (
    <Navigate to={`/${language}`} replace />
  );
};

// Language validation
const LanguageWrapper = () => {
  const { lang } = useParams();
  const supportedLangs = ["en", "am", "ru"];

  if (!supportedLangs.includes(lang)) {
    return <Navigate to="/am" replace />;
  }

  return <Outlet />;
};

export const routes = [
  {
    path: "/",
    element: <Navigate to="/am" replace />,
  },

  {
    path: "/:lang",
    element: <LanguageWrapper />,
    children: [
      {
        index: true,
        element: isAuthenticated() ? (
          <Navigate to="dashboard" replace />
        ) : (
          <Login />
        ),
      },

      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <DashBoard />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },

      {
        path: "services",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Services />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },

      {
        path: "statistics",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Statistics />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },

      {
        path: "orders",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Orders />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },

      {
        path: "settings",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Settings />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },
      {
        path: "calendar",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Calendar />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },
      {
        path: "finances",
        element: (
          <ProtectedRoute>
            {/* <SuspenseWrapper> */}
              <Finances />
            {/* </SuspenseWrapper> */}
          </ProtectedRoute>
        ),
      },
    ],
  },

  // GLOBAL 404 (IMPORTANT)
  {
    path: "*",
    element: <NotFound />,
  },
];
